import axios from 'axios';

const revertMatch = async (matchId, setData, comparisonID) => {
  let updatedData = null;

  setData((prevData) => {
    if (
      !prevData ||
      !prevData.results ||
      !prevData.cleanParsedEstData ||
      !prevData.cleanParsedInsData
    ) {
      console.error("❌ Missing expected data structure");
      return prevData;
    }

    const newData = structuredClone(prevData);

    const result = newData.results.find((r) => r.id === matchId);
    if (!result) {
      console.error(`❌ No result found for matchId: ${matchId}`);
      return prevData;
    }

    const matchObj = result.Matches[0];
    const matchKey = Object.keys(matchObj)[0];
    const matchBlock = matchObj[matchKey];

    const userModified = matchBlock["User Modified"];
    const systemDetected = matchBlock["System Detected"];

    if (!userModified || !systemDetected) {
      console.error(`❌ Missing User Modified or System Detected block for matchId: ${matchId}`);
      return prevData;
    }

    const getAllUniqueIds = (...blocks) => {
      const allIds = [];
      for (const block of blocks) {
        if (block?.doc1?.ids) allIds.push(...block.doc1.ids);
        if (block?.doc2?.ids) allIds.push(...block.doc2.ids);
      }
      return [...new Set(allIds)];
    };

    const allDoc1Ids = getAllUniqueIds(userModified, systemDetected).filter(id => id.startsWith("li1"));
    const allDoc2Ids = getAllUniqueIds(userModified, systemDetected).filter(id => id.startsWith("li2"));

    const updateZoneForIds = (lineItemsArray, ids, label) => {
      ids.forEach((targetId) => {
        let found = false;
        for (const obj of lineItemsArray) {
          const key = Object.keys(obj)[0];
          const item = obj[key];
          if (key === targetId && item) {
            item.userModifiedZone = item.detectedZone;
            item.locked = false; // ✅ always unlock
            found = true;
            break;
          }
        }
        if (!found) {
          console.warn(`⚠️ Could not find ${targetId} in ${label}`);
        }
      });
    };

    updateZoneForIds(newData.cleanParsedEstData.lineItems, allDoc1Ids, "EstData");
    updateZoneForIds(newData.cleanParsedInsData.lineItems, allDoc2Ids, "InsData");

    matchBlock["User Modified"] = JSON.parse(JSON.stringify(systemDetected));

    updatedData = newData; // capture for use outside setState
    return newData;
  });

  // Wait one tick to ensure state has been applied
  await new Promise((resolve) => setTimeout(resolve, 0));

  if (!updatedData) {
    console.error("❌ No updated data available for DB sync");
    return;
  }

  try {
    const zone1URL = `${process.env.REACT_APP_ZONE1_UPDATE}/${comparisonID}`;
    const zone2URL = `${process.env.REACT_APP_ZONE2_UPDATE}/${comparisonID}`;
    const resultsURL = `${process.env.REACT_APP_UPDATE_RESULTS}/${updatedData?.resultsID}`;

    const [zone1Res, zone2Res, resultsRes] = await Promise.all([
      axios.put(zone1URL, { cleanParsedEstData: updatedData.cleanParsedEstData }),
      axios.put(zone2URL, { cleanParsedInsData: updatedData.cleanParsedInsData }),
      axios.put(resultsURL, { data: updatedData }),
    ]);

  } catch (error) {
    console.error("❌ Error updating DB:", error);
  }
};

export default revertMatch;
